export default __webpack_public_path__ + "static/B18-e68d9f9a743c856512ad5c16964b92a8.png";